import { render } from "./pageFormModal.vue?vue&type=template&id=e04a195c&ts=true"
import script from "./pageFormModal.vue?vue&type=script&lang=ts"
export * from "./pageFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__